import { cx } from '@emotion/css';
import { ArrowForward } from '@mui/icons-material';
import { getConfig } from '@sortlist-frontend/config';
import { Button } from '@sortlist-frontend/design-system/legacy';
import { useTranslation } from '@sortlist-frontend/translation';
import { removeStorage } from '@sortlist-frontend/utils';
import { FC } from 'react';

import { getProjectData } from '../utils';

type Props = {
  className?: string;
  setIsProjectBannerShown: (show: boolean) => void;
};

export const ProjectBanner: FC<Props> = (props) => {
  const { className, setIsProjectBannerShown } = props;
  const { t } = useTranslation(['common']);
  const { publicEnv } = getConfig();

  const goToProject = () => {
    const projectData = getProjectData();
    if (!projectData) return false;

    const { token, projectId } = projectData;

    const url = `${publicEnv.clientAppUrl}/projects/${projectId}`;
    window.location.href = url;
  };

  return (
    <div className={cx(className, 'bg-primary-200')} data-testid="project-banner">
      <div className="py-2 text-primary-500 container-lg layout-gt-xs-row layout-align-space-between-center">
        <p className={cx('small max-sm:mb-1')}>{t('common:projectBanner.description')}</p>

        <div className="layout-column layout-gt-xs-row layout-align-start-start layout-gt-xs-align-end-center">
          <Button
            size="xxs"
            label={t('common:projectBanner.dontShowAgain')}
            buttonStyle="primary"
            buttonVariant="default"
            className="mr-2 max-sm:mb-1 underline"
            onClick={() => {
              removeStorage('projectData');
              setIsProjectBannerShown(false);
            }}
            truncate={false}
          />
          <Button
            size="xxs"
            label={t('common:projectBanner.goToProject')}
            buttonStyle="primary"
            buttonVariant="outlined"
            iconRight={<ArrowForward />}
            onClick={goToProject}
            truncate={false}
          />
        </div>
      </div>
    </div>
  );
};
